import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const downloadPendingFeesPDF = ({
    reportData,
    selectedYear1,
    selectedStdName,
    selectedDivName
}) => {

    const formatAmount = (amount) => {

        return Number(amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    };

    const doc = new jsPDF("landscape", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const now = new Date();
    const timestamp = now.toLocaleString();

    //==========================
    // Header
    //==========================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 102, 204);
    doc.text("St. Haris High School", pageWidth / 2, 15, {
        align: "center",
    });

    doc.setFontSize(11);
    doc.setTextColor(0);

    doc.text(
        `Pending Fees Report (${selectedYear1}-${Number(selectedYear1) + 1})`,
        pageWidth / 2,
        22,
        { align: "center" }
    );

    doc.setDrawColor(180);
    doc.line(14, 28, pageWidth - 14, 28);

    //==========================
    // Build Rows
    //==========================

    const pdfRows = [];

    let currentStdDiv = "";
    let stdDivTotal = 0;
    let grandTotal = 0;

    reportData.forEach((row, index) => {

        // Std/Div changed
        if (currentStdDiv && currentStdDiv !== row.std_div) {

            pdfRows.push({
                type: "subtotal",
                data: [
                    "",
                    "",
                    "",
                    `Total (${currentStdDiv})`,
                    "",
                    formatAmount(stdDivTotal),
                ],
            });

            stdDivTotal = 0;
        }

        currentStdDiv = row.std_div;

        pdfRows.push({
            type: "data",
            data: [
                row.sect_prefix,
                row.std_div,
                row.gr_no,
                row.stud_name,
                row.pend_from,
                formatAmount(row.pending_amount),
            ],
        });

        stdDivTotal += Number(row.pending_amount || 0);
        grandTotal += Number(row.pending_amount || 0);

        // Last Record
        if (index === reportData.length - 1) {

            pdfRows.push({
                type: "subtotal",
                data: [
                    "",
                    "",
                    "",
                    `Total (${currentStdDiv})`,
                    "",
                    formatAmount(stdDivTotal),
                ],
            });

            pdfRows.push({
                type: "grand",
                data: [
                    "",
                    "",
                    "",
                    "GRAND TOTAL",
                    "",
                    formatAmount(grandTotal),
                ],
            });

        }

    });

    //==========================
    // AutoTable
    //==========================

    autoTable(doc, {

        startY: 34,

        head: [[
            "Section",
            "Std / Div",
            "GR No.",
            "Student Name",
            "Pending From",
            "Pending Amount"
        ]],

        body: pdfRows.map(r => r.data),

        theme: "grid",

        styles: {
            fontSize: 8,
            cellPadding: 2,
            overflow: "linebreak",
            lineColor: [220, 220, 220]
        },

        headStyles: {
            fillColor: [0, 102, 204],
            textColor: 255,
            fontStyle: "bold",
            halign: "center",
            fontSize: 9
        },

        columnStyles: {

            0: {
                cellWidth: 20,
                halign: "center"
            },

            1: {
                cellWidth: 22,
                halign: "center"
            },

            2: {
                cellWidth: 25,
                halign: "center"
            },

            3: {
                cellWidth: 95,
                halign: "left"
            },

            4: {
                cellWidth: 28,
                halign: "center"
            },

            5: {
                cellWidth: 35,
                halign: "right"
            }

        },

        // didParseCell: function (data) {

        //   if (data.section !== "body")
        //     return;

        //   const rowType = pdfRows[data.row.index].type;

        //   // Student Rows
        //   if (rowType === "data") {

        //     data.cell.styles.fontStyle = "normal";

        //   }

        //   // Subtotal
        //   if (rowType === "subtotal") {

        //     data.cell.styles.fillColor = [242, 242, 242];
        //     data.cell.styles.fontStyle = "bold";
        //     data.cell.styles.fontSize = 9;

        //   }

        //   // Grand Total
        //   if (rowType === "grand") {

        //     data.cell.styles.fillColor = [209, 236, 241];
        //     data.cell.styles.textColor = [0, 70, 140];
        //     data.cell.styles.fontStyle = "bold";
        //     data.cell.styles.fontSize = 10;

        //   }

        // },

        didParseCell: function (data) {

            // Header alignment
            if (data.section === "head") {

                if (data.column.index === 3) {
                    data.cell.styles.halign = "left";
                } else {
                    data.cell.styles.halign = "center";
                }

                return;
            }

            const rowType = pdfRows[data.row.index].type;

            // Student Rows
            if (rowType === "data") {
                data.cell.styles.fontStyle = "normal";
            }

            // Subtotal
            if (rowType === "subtotal") {
                data.cell.styles.fillColor = [242, 242, 242];
                data.cell.styles.fontStyle = "bold";
                data.cell.styles.fontSize = 9;
            }

            // Grand Total
            if (rowType === "grand") {
                data.cell.styles.fillColor = [209, 236, 241];
                data.cell.styles.textColor = [0, 70, 140];
                data.cell.styles.fontStyle = "bold";
                data.cell.styles.fontSize = 10;
            }
        },

        didDrawPage: function () {

            const pageNumber = doc.getNumberOfPages();

            doc.setFontSize(8);
            doc.setTextColor(120);

            doc.line(14, pageHeight - 14, pageWidth - 14, pageHeight - 14);

            doc.text(
                "eSchool",
                14,
                pageHeight - 8
            );

            doc.text(
                `Generated : ${timestamp}`,
                pageWidth / 2,
                pageHeight - 8,
                {
                    align: "center"
                }
            );

            doc.text(
                `Page ${pageNumber}`,
                pageWidth - 14,
                pageHeight - 8,
                {
                    align: "right"
                }
            );

        }

    });

    doc.save(
        `Pending_Fees_Report_${selectedYear1}.pdf`
    );
};